// React imports.
import React, { Component } from "react";

// App imports.
import VendorsReportedTable from "./VendorsReportedTable";
import Assessment2TopParagraph from "./Assessment2TopParagraph";
import Assessment2BottomText from "./Assessment2BottomText";
import Assessment2Questions from "./Assessment2Questions";
import Assessment2ActionPlan from "./Assessment2ActionPlan";
import Assessment2DownloadCSV from "./Assessment2DownloadCSV";
import TableLegend from "./TableLegend";


import { Assessment2StepsEnum } from "../state";
import { Assessment2FuelStatusEnum } from "../state";


const Assessment2 = ({ state }) => (
      <div>
          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.TotalVendors &&
                <div>
                    <p>
                        <strong><u>Step 1:</u> Enter the Number of Vendors Serving LIHEAP Clients in Your State/Territory</strong>
                    </p>
                    <p>
                        All LIHEAP grantees are required to collect main heating expenditure data for LIHEAP clients from at least the the following number of vendors for each fuel type:
                    </p>
                    <ul>
                        <li>
                            The 5 largest electricity vendors in the state/territory
                        </li>
                        <li>
                            The 5 largest natural gas vendors in the state/territory
                        </li>
                        <li>
                            The 10 largest fuel oil vendors in the state/territory
                        </li>
                        <li>
                            The 10 largest propane vendors in the state/territory
                        </li>
                    </ul>
                    <p>
                        If your state has fewer than 5 electric or natural gas vendors, or fewer than 10 fuel oil or propane vendors, you should try to collect data from all  the vendors who participate in the LIHEAP program. For example, if your state only has four natural gas vendors participating in the LIHEAP program, you should try to collect data from all four of those vendors.
                    </p>
                    <p>
                        The first step of Assessment #2 is to establish a baseline number of vendors serving clients in your state/territory for each fuel type. This information is NOT reported in your annual Performance Measures Form, so you will need to provide it from your own records. For the purposes of this assessment, a vendor can be defined as a company, utility, or cooperative that provides LIHEAP clients with their main heating fuel. 
                    </p>
                    <VendorsReportedTable  fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />
                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.VendorsRequested &&
                <div>
                    <p>
                        <strong><u>Step 2:</u> Enter the Number of Vendors from Whom Data was <i>Requested</i></strong>
                    </p>
                    <p>
                        The next step of Assessment #2 is to check if you <i>requested</i> data from the minimum required number of vendors
                        for each fuel type. The number of vendors for whom data was requested is NOT reported in your annual Performance
                        Measures Form, so you will need to provide this information from your own records

                    </p>
                    <p>
                      <strong>For each fuel type in the table below, enter the number vendors from whom your office
                      requested main heating expenditure data.</strong> As a reminder, a vendor can be defined as a
                      company, utility, or cooperative that provides LIHEAP clients with their main heating fuel. 
                    </p>
                    <VendorsReportedTable fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />

                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.VendorsReceived &&
                <div>
                    <p>
                        <strong><u>Step 3:</u> Enter the Number of Vendors from Whom Data was <i>Received</i></strong>
                    </p>
                    <p>
                        The third step of Assessment #2 is to check if you actually <i>received</i> data from the
                        minimum number of vendors for each fuel type. The number of vendors from whom data
                        was received is NOT reported in your annual Performance Measures Form, so you will need to
                        provide this information from your own records. 
                    </p>
                    <p>
                        <strong>For each fuel type in the table below, enter the number vendors from whom your office actually received main heating expenditure data.</strong>
                        We are continuing to define a vendor as a company, utility, or cooperative that provides LIHEAP clients with their main heating fuel. 
                    </p>
                    <VendorsReportedTable fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />

                </div>
          }
          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.VendorsStatus &&
                <div>
                    <p>
                        <strong><u>Step 4:</u> Results Overview</strong>
                    </p>
                    <p>
                        Now that you have provided the necessary information, we can check to see if you
                        have requested and/or received main heating expenditure data from the minimum number
                        of vendors for each fuel type.
                        The table below shows an overview of your results for Assessment #2. Each fuel type
                        will be flagged for a potential data reliability issue if:
                    </p>
                    <ol>
                        <li>You did not request data from the minimum number of vendors; or</li>
                        <li>You did not receive data from the minimum number of vendors.</li>
                    </ol>
                    <p>
                        These results are explored more thoroughly for each fuel type in Steps 4a-4d.
                    </p>
                    <VendorsReportedTable fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />

                </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.ElectricDetail &&
                <div>
                    <p>
                        <strong><u>Step 4a:</u> Results - Electric Heat Households</strong>
                    </p>
                    <p>
                        <Assessment2TopParagraph fuelType={state.Assessment2FuelTypesStatus.Electric} />
                    </p>
                    <VendorsReportedTable fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />
                    <Assessment2BottomText state={state}  fuelType={state.Assessment2FuelTypesStatus.Electric} />
                    {(state.Assessment2FuelTypesStatus.Electric.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.Electric.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.Electric.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.Electric.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.Electric.viewAnyway === true)
                        && <Assessment2Questions fuelType={state.Assessment2FuelTypesStatus.Electric}  state={state} />}
                </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.NaturalGasDetail &&
                <div>
                    <p>
                        <strong><u>Step 4b:</u> Results - Natural Gas Households</strong>
                    </p>
                    <p>
                        <Assessment2TopParagraph fuelType={state.Assessment2FuelTypesStatus.NaturalGas} />
                    </p>
                    <VendorsReportedTable fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />
                    <br />
                    <Assessment2BottomText state={state}  fuelType={state.Assessment2FuelTypesStatus.NaturalGas} />
                    {(state.Assessment2FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.NaturalGas.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.NaturalGas.viewAnyway === true)
                        && <Assessment2Questions fuelType={state.Assessment2FuelTypesStatus.NaturalGas}  state={state} />}
                </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.FuelOilDetail &&
                <div>
                    <p>
                        <strong><u>Step 4c:</u> Results - Fuel Oil Households</strong>
                    </p>
                    <p>
                        <Assessment2TopParagraph fuelType={state.Assessment2FuelTypesStatus.FuelOil} />
                    </p>
                    <VendorsReportedTable  fieldChangeHandler={state.assessment2FieldChangeHandler} holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />
                    <Assessment2BottomText state={state}  fuelType={state.Assessment2FuelTypesStatus.FuelOil} />
                    {(state.Assessment2FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.FuelOil.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.FuelOil.viewAnyway === true)
                        && <Assessment2Questions fuelType={state.Assessment2FuelTypesStatus.FuelOil}  state={state} />}
                </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.PropaneDetail &&
                <div>
                    <p>
                        <strong><u>Step 4d:</u> Results - Propane Households</strong>
                    </p>
                    <p>
                        <Assessment2TopParagraph fuelType={state.Assessment2FuelTypesStatus.Propane} />
                    </p>
                    <VendorsReportedTable fieldChangeHandler={state.assessment2FieldChangeHandler}  holder={state.Assessment2FuelTypesStatus} step={state.Assessment2Steps[state.CurrentAssessementStepIndex]} state={state} />
                    <br />
                    <Assessment2BottomText state={state}  fuelType={state.Assessment2FuelTypesStatus.Propane} />
                    {(state.Assessment2FuelTypesStatus.Propane.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.Propane.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.OverMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.Propane.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughReceived
                      ||state.Assessment2FuelTypesStatus.Propane.vendorsSubmittingDataStatus == Assessment2FuelStatusEnum.UnderMinNotEnoughRequested
                      ||state.Assessment2FuelTypesStatus.Propane.viewAnyway === true)
                        && <Assessment2Questions fuelType={state.Assessment2FuelTypesStatus.Propane}  state={state} />}
                </div>
          }

          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.ActionPlanSummary &&
              <div>
                  <p>
                      <strong><u>Step 5:</u> Aggregated Action Plan </strong>
                  </p>
                  <p>
                      Congratulations! You have reached the end of Assessment #2. Your aggregated action plan for every issue
                      identified in Assessment #2 is included in the table below. You can now download or print the Assessment
                      #2 action plan below. Also, you can revisit this page at any time by selecting it from the list of completed
                      assessment on the Assessment Tool Selection Page. 
                  </p>
                  <table id="tblDataReliabilityActionPlan">
                      <thead>
                        <tr>
                            <th>Fuel</th>
                            <th>Issue</th>
                            <th>Action Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                      {state.assessment2GetFuelTypesArray().map(fuel => {
                          return (
                              <React.Fragment>
                                  {(fuel.clientWaiversMeetVendorRequirements === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors requirements for data security and privacy</td>
                                    <td>
                                      {fuel.clientWaiversMeetVendorRequirementsDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.vendorAgreementsHaveDataCollectionRequirements === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors agreements have data collection requirements</td>
                                    <td>
                                      {fuel.vendorAgreementsHaveDataCollectionRequirementsDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.vendorsAlertedTimelyManner === false)
                                  &&
                                  <tr>
                                    <td>{fuel.description}</td>
                                    <td>Vendors alerted in a timely manner</td>
                                    <td>
                                      {fuel.vendorsAlertedTimelyMannerDesc}
                                    </td>
                                  </tr>}
                                  {(fuel.showSetUpMeeting == true)
                                  &&
                                  <tr>
                                      <td>{fuel.description}</td>
                                      <td>
                                          Please set up a meeting with vendors to figure out
                                          what can be done to ensure that you receive all the necessary data.
                                      </td>
                                      <td>
                                        {fuel.setUpMeetingDesc}
                                      </td>
                                  </tr>}
                              </React.Fragment>
                          )
                      })}
                      </tbody>
                  </table>
              </div>
          }

          {state.CurrentAssessementStepIndex != Assessment2StepsEnum.ActionPlanSummary
          &&
              <TableLegend />    
          }

                
          <button className="dataButton"
              onClick={() => state.assessment2ShowPreviousStep()}>
              Previous
          </button>
          {state.CurrentAssessementStepIndex < Assessment2StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment2ShowNextStep()}
                  disabled={state.Assessment2ShowNextStepDisabled === true}>
                  Next
              </button>
          }

          {state.CurrentAssessementStepIndex < Assessment2StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => state.assessment2ShowActionPlan()}
                  disabled={state.Assessment2ShowNextStepDisabled === true}>
                  View Action Plan
              </button>
          }

          <br/>
          <button className="dataButton"
              onClick={() => state.backToStart()}>
              {state.CurrentAssessementStepIndex < Assessment2StepsEnum.ActionPlanSummary
              &&<React.Fragment>Back to start</React.Fragment>}
              {state.CurrentAssessementStepIndex === Assessment2StepsEnum.ActionPlanSummary
              &&<React.Fragment>Finish &amp; Save</React.Fragment>}
          </button>
          {state.CurrentAssessementStepIndex === Assessment2StepsEnum.ActionPlanSummary
          &&
              <button className="dataButton"
                  onClick={() => window.print()}>
                  Print
              </button>
          }
          {state.CurrentAssessementStepIndex == Assessment2StepsEnum.ActionPlanSummary
          &&
            <Assessment2DownloadCSV fuelTypes={[state.Assessment2FuelTypesStatus.Electric, state.Assessment2FuelTypesStatus.NaturalGas, , state.Assessment2FuelTypesStatus.FuelOil, state.Assessment2FuelTypesStatus.Propane]}/>
          }
        
          <div style={{clear:"both"}}>&nbsp;</div>
      </div>
    );

export default Assessment2;
